import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Room} from '../models/room';

const API = environment.API;

@Injectable({
  providedIn: 'root'
})
export class RoomService {

  constructor(private http: HttpClient) {
  }

  createRoom(
    placeId: string,
    calendarId: string,
    name: string,
    image: string,
    maxSeats: number,
    hourlyRate: number,
    currency: string,
    minHours: number,
    maxHours: number,
    timeOfDay: any,
    smallImages: string[],
    mediumImages: string[],
    largeImages: string[]
  ) {
    const body = {
      placeId,
      calendarId,
      name,
      image,
      maxSeats,
      hourlyRate,
      currency,
      minHours,
      maxHours,
      timeOfDay,
      smallImages,
      mediumImages,
      largeImages
    };
    return this.http.post(`${API}/api/rooms`, body);
  }

  getById(roomId: string) {
    return this.http.get<Room>(`${API}/api/rooms/${roomId}`);
  }

  getBySlug(slug: string) {
    return this.http.get<Room>(`${API}/api/rooms/${slug}/slug`);
  }

  findByPlaceId(placeId: string, showInvisible = false, limit = 1000, skip = 0) {
    const params = {showInvisible, limit, skip}
    return this.http.get<Room[]>(`${API}/api/rooms/place/${placeId}`, {params});
  }

  findRooms(limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Room[]>(`${API}/api/rooms`, {params});
  }

  findByRegion(regionSlug: string, limit = 1000, skip = 0) {
    const params = {limit, skip};
    return this.http.get<Room[]>(`${API}/api/rooms/region/${regionSlug}`, {params});
  }

  findByGeolocation(latitude: number, longitude: number, radius: number, showInvisible: boolean = false, limit = 1000, skip = 0) {
    const params = {latitude, longitude, radius, showInvisible, limit, skip};
    return this.http.get<Room[]>(`${API}/api/rooms/geolocation`, {params});
  }

  search(search: string, showInvisible: boolean = false, limit = 1000, skip = 0) {
    const params = {search, showInvisible, limit, skip};
    return this.http.get(`${API}/api/rooms/search`, {params});
  }

  getAvailabilities(roomId: string, placeId: string, localBegin: string, localEnd: string, durationHours: number, displayTime: string) {
    const params = {placeId, localBegin, localEnd, durationHours, displayTime};
    return this.http.get(`${API}/api/rooms/availabilities/${roomId}`, {params});
  }

  update(
    roomId: string,
    calendarId: string,
    name: string,
    image: string,
    maxSeats: number,
    hourlyRate: number,
    currency: string,
    minHours: number,
    maxHours: number,
    timeOfDay: any,
    smallImages: string[],
    mediumImages: string[],
    largeImages: string[]
  ) {
    const body = {
      calendarId,
      name,
      image,
      maxSeats,
      hourlyRate,
      currency,
      minHours,
      maxHours,
      timeOfDay,
      smallImages,
      mediumImages,
      largeImages
    };
    return this.http.put(`${API}/api/rooms/${roomId}`, body);
  }

  updateActive(roomId: string, active: boolean) {
    const body = {active};
    return this.http.put(`${API}/api/rooms/${roomId}/active`, body);
  }

  updateImage(roomId: string, imageId: string) {
    const body = {imageId};
    return this.http.put(`${API}/api/rooms/${roomId}/image`, body);
  }

  deactivate(roomId: string) {
    return this.http.put(`${API}/api/rooms/${roomId}/deactivate`, {});
  }

}
